import request from '@/utils/request';

// 获取客户端列表
export async function getClients() {
  return request('/client/getClients');
}

// 新增客户端
export async function addClient(client) {
  return request('/client/addClient', {
    method: 'POST',
    body: {
      ...client,
    },
  });
}

// 修改客户端
export async function updateClient(client) {
  return request('/client/updateClient', {
    method: 'PUT',
    body: {
      ...client,
    },
  });
}

// 删除客户端
export async function deleteClient(clientId) {
  return request(`/client/${clientId}/delete/`, {
    method: 'DELETE',
  });
}
